import gql from 'graphql-tag';
import { templateRequestGQLFields, } from './templateRequest.fields.js';
export function getTemplateRequestGQLQuery(fields) {
    return gql `
    query templateRequest($id: String!) {
      templateRequest(id: $id) {
        ${templateRequestGQLFields(fields)}
      }
    }
  `;
}
//# sourceMappingURL=templateRequest.gql.js.map